// Page de confirmation (route /merci) — affichée après la réservation cal.com.
// Présentationnel : le tracking de conversion (APPLICATION_SUBMITTED) est déjà
// déclenché côté funnel, avant la redirection.

// Nom affiché en signature — configurable via NEXT_PUBLIC_ORGANIZER_NAME.
import { ORGANIZER_NAME } from "@/lib/config";

const PREP_STEPS: [string, string][] = [
  [
    "Un chiffre",
    "combien d’heures par semaine vous passez sur les tâches à faible valeur (CR, reportings, slides, relances).",
  ],
  [
    "La tâche qui vous pèse le plus",
    "celle où vous vous dites « il doit y avoir une meilleure façon de faire ».",
  ],
  [
    "Vos outils",
    "plutôt Microsoft (Outlook/Teams) ou Google (Gmail/Drive) ?",
  ],
];

export function ThankYou({ firstName }: { firstName?: string }) {
  const prenom = firstName?.trim();

  return (
    <div className="mx-auto w-full max-w-xl text-center">
      <span className="mb-5 inline-flex items-center rounded-full border border-brand/30 bg-brand/10 px-3 py-1 text-xs font-medium text-brand">
        Entretien confirmé ✅
      </span>

      <h1 className="text-balance text-2xl font-extrabold sm:text-3xl">
        C’est réservé. On se retrouve bientôt.
      </h1>

      <p className="mx-auto mt-4 text-pretty text-ink/70">
        {prenom ? `${prenom}, votre` : "Votre"} entretien est confirmé — vous
        recevez le lien et les détails par email dans la minute (vérifiez vos
        spams, au cas où).
      </p>

      <div className="mt-8 rounded-2xl border border-ink/10 bg-white p-6 text-left">
        <p className="font-semibold text-ink">
          Pour en tirer le maximum, préparez ça en 5 minutes :
        </p>
        <ol className="mt-4 space-y-4">
          {PREP_STEPS.map(([title, detail], i) => (
            <li key={title} className="flex items-start gap-3">
              <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-gold text-sm font-bold text-ink">
                {i + 1}
              </span>
              <p className="text-sm text-ink/80">
                <span className="font-semibold text-ink">{title}</span> — {detail}
              </p>
            </li>
          ))}
        </ol>
      </div>

      <p className="mx-auto mt-6 max-w-md text-sm text-ink/70">
        Venez au calme, avec 20 minutes devant vous sans interruption. Les managers
        qui tirent le plus de cet échange sont ceux qui arrivent avec ces éléments
        en tête.
      </p>

      <p className="mt-6 text-sm text-ink/80">
        À très vite,
        <br />
        <span className="font-semibold text-ink">{ORGANIZER_NAME}</span>
      </p>

      <p className="mt-6 text-xs text-ink/45">
        Un imprévu ? Vous pouvez décaler depuis l’email de confirmation.
      </p>
    </div>
  );
}
